import { render, staticRenderFns } from "./PassengerDetailsList.vue?vue&type=template&id=11ce3474&"
import script from "./PassengerDetailsList.vue?vue&type=script&lang=js&"
export * from "./PassengerDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports